import React, { ChangeEvent, SyntheticEvent, useEffect, useState } from "react";
import { CompanySearch } from "../../company";
import { searchCompanies } from "../../api";
import Navbar from "../../Components/Navbar/Navbar";
import Search from "../../Components/Search/Search";
import ListPortfolio from "../../Components/Portfolio/ListPortfolio/ListPortfolio";
import CardList from "../../Components/CardList/CardList";
import { PortfolioGet } from "../../Models/Portfolio";
import { get } from "http";
import {
  addPortfolioAPI,
  deletePortfolioAPI,
  getPortfolioAPI,
} from "../../Services/PortfolioService";
import { toast } from "react-toastify";

interface Props {}

const SearchPage = (props: Props) => {
  const [search, setSearch] = useState<string>("");
  const [portfolioValues, setPortfolioValues] = useState<PortfolioGet[] | null>([]);
  const [searchResult, setSearchResult] = useState<CompanySearch[]>([]);
  const [serverError, setServerError] = useState<string>("");
  const [hasSearched, setHasSearched] = useState<boolean>(false);

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    console.log(e);
  };

  useEffect(() => {
    getPortfolio();
  }, []);

  const getPortfolio = async () => {
    getPortfolioAPI()
      .then((response) => {
        if (response && response.data) {
          setPortfolioValues(response?.data);
        }
      })
      .catch((error) => {
        toast.warning("Failed to load portfolio data.");
      });
  };

  const onSearchClick = async (e: SyntheticEvent) => {
    e.preventDefault();
    setServerError("");
    setSearchResult([]);
    setHasSearched(true);
    const result = await searchCompanies(search);
    if (typeof result === "string") {
      setServerError(result);
    } else if (Array.isArray(result.data)) {
      setSearchResult(result.data);
    }
    console.log(searchResult);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearchClick(e);
    }
  };

  const onPortfolioCreate = (e: any) => {
    e.preventDefault();
    addPortfolioAPI(e.target[0].value)
      .then((response) => {
        if (response && response.status === 204) {
          toast.success("Added to portfolio!");
          getPortfolio();
        }
      })
      .catch((error) => {
        toast.warning("Failed to add to portfolio.");
      });
  };

  const onPortfolioDelete = (e: any) => {
    e.preventDefault();
    deletePortfolioAPI(e.target[0].value)
      .then((response) => {
        if (response && response.status === 200) {
          toast.success("Removed from portfolio!");
          getPortfolio();
        }
      })
      .catch((error) => {
        toast.warning("Failed to remove from portfolio.");
      });
  };

  return (
    <div className="App">
      <Search
        onSearchClick={onSearchClick}
        search={search}
        handleSearchChange={handleSearchChange}
        handleKeyDown={handleKeyDown}
      />
      <ListPortfolio portfolioValues={portfolioValues!} onPortfolioDelete={onPortfolioDelete} />
      {serverError && <h1>{serverError}</h1>}
      {!serverError && (
        <CardList
          searchResults={searchResult}
          hasSearched={hasSearched}
          onPortfolioCreate={onPortfolioCreate}
        />
      )}
    </div>
  );
};

export default SearchPage;
